import { ReactNode, type JSX } from 'react';
import { cn } from '@c2fo/liquidity';

interface NoDataStateProps {
  icon?: JSX.Element;
  title?: string;
  message?: string | ReactNode;
  action?: JSX.Element;
  className?: string;
  inverse?: boolean;
  dark?: boolean;
}

const NoDataState = ({ icon, title, message, action, className, inverse, dark }: NoDataStateProps) => {
  return (
    <div className={cn('m-auto flex flex-col items-center justify-center', className)}>
      {icon && <div>{icon}</div>}
      {title && (
        <h3
          className={cn('m-0 text-center text-lg font-normal capitalize text-text-secondary sm:text-2xl', {
            'text-white': inverse,
            'font-semibold text-text-primary': dark,
          })}
        >
          {title}
        </h3>
      )}
      {message && (
        <p
          className={cn('max-w-md text-wrap text-center text-text-secondary', {
            'text-white': inverse,
            'pb-4': !!action,
            'text-text-primary': dark,
          })}
        >
          {message}
        </p>
      )}
      {action && <div>{action}</div>}
    </div>
  );
};

export default NoDataState;
